import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

const orders = createApi({
    reducerPath: 'orders',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getListProducts: builder.mutation({
            query: (param) => ({
                url: 'orders/getListProducts',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        saveShoppingBag: builder.mutation({
            query: (param) => ({
                url: 'orders/saveShoppingBag',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getShoppingBag: builder.mutation({
            query: (param) => ({
                url: 'orders/getShoppingBag',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        createOrder: builder.mutation({
            query: (param) => ({
                url: 'orders/createOrder',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getListOrders: builder.mutation({
            query: (param) => ({
                url: 'orders/getListOrders',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getOrderDetails: builder.mutation({
            query: (param) => ({
                url: 'orders/getOrderDetails',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getOrderById: builder.mutation({
            query: (param) => ({
                url: 'orders/getOrderById',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        cancelOrder: builder.mutation({
            query: (param) => ({
                url: 'orders/cancelOrder',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        confirmOrder: builder.mutation({
            query: (param) => ({
                url: 'orders/confirmOrder',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
    }),
});
export const { useGetListProductsMutation, useSaveShoppingBagMutation, useGetShoppingBagMutation
    , useCreateOrderMutation, useGetListOrdersMutation, useGetOrderDetailsMutation, useCancelOrderMutation
    , useConfirmOrderMutation, useGetOrderByIdMutation } = orders;
export default orders;